import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketingContainerComponent } from './marketing-container.component';
import { SafePipeModule } from 'safe-pipe';

@NgModule({
    declarations: [
        MarketingContainerComponent
    ],
    imports: [
        CommonModule,
        SafePipeModule
    ],
    exports: [
        MarketingContainerComponent
    ]
})
export class MarketingContainerModule { }
